import { FC, useMemo } from 'react';
import moment from 'moment-timezone';
import useAuthSelector from 'modules/shared/hooks/useAuthSelector';

interface TzDateFormatterProps {
    date: Date;
    format: string;
}

const TzDateFormatter: FC<TzDateFormatterProps> = (props) => {
    const { date, format } = props;

    const { user } = useAuthSelector();

    const formattedDate = useMemo(() => {
        if (!date) return '-';

        const _date = moment(date).tz(user.preferences.timezone);

        if (_date && _date.isValid()) return _date.format(format);

        return '-';
    }, [date, format, user.preferences.timezone]);

    return <>{formattedDate}</>;
};

export default TzDateFormatter;
